import { render, staticRenderFns } from "./ProductTabsTile.vue?vue&type=template&id=89fa45a2&scoped=true&"
import script from "./ProductTabsTile.vue?vue&type=script&lang=js&"
export * from "./ProductTabsTile.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsTile.vue?vue&type=style&index=0&id=89fa45a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa45a2",
  null
  
)

export default component.exports